"use client";

import dynamic from "next/dynamic";

const LegacyAgentsCalculator = dynamic(
  () => import("./LegacyAgentsCalculator").then(mod => mod.LegacyAgentsCalculator),
  {
    ssr: false,
  },
);

export function LegacyAgentsCalculatorWrapper() {
  return <LegacyAgentsCalculator variant='agents' />;
}
